import { render, staticRenderFns } from "./CeoModerationView.vue?vue&type=template&id=b46d9c70"
import script from "./CeoModerationView.vue?vue&type=script&lang=js"
export * from "./CeoModerationView.vue?vue&type=script&lang=js"
import style0 from "./CeoModerationView.vue?vue&type=style&index=0&id=b46d9c70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports